import Vue from 'vue';
import App from './App.vue';

// 引入 element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 引入请求函数
import http from './api/axios';
Vue.prototype.$http = http;

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
